import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Base_Url } from '../config';

const NewsManagement = () => {
    const [news, setNews] = useState([]);
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        external_link: '',
        internal_link: '',
        image: null
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const fetchNews = async () => {
        try {
            const response = await axios.get(`${Base_Url}/newsandannouncement`);
            setNews(response.data);
        } catch (err) {
            setError('Failed to fetch news');
            console.error('Error fetching news:', err);
        }
    };

    useEffect(() => {
        fetchNews();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileChange = (e) => {
        setFormData(prev => ({
            ...prev,
            image: e.target.files[0]
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccessMessage('');

        try {
            const formDataToSend = new FormData();
            formDataToSend.append('title', formData.title);
            formDataToSend.append('description', formData.description);
            formDataToSend.append('external_link', formData.external_link);
            formDataToSend.append('internal_link', formData.internal_link);
            if (formData.image) {
                formDataToSend.append('image', formData.image);
            }

            await axios.post(`${Base_Url}/newsandannouncement`, formDataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            setSuccessMessage('News added successfully!');
            setFormData({
                title: '',
                description: '',
                external_link: '',
                internal_link: '',
                image: null
            });
            fetchNews();
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to add news');
            console.error('Error adding news:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this news item?')) {
            return;
        }

        try {
            await axios.delete(`${Base_Url}/newsandannouncement/${id}`);
            setSuccessMessage('News deleted successfully!');
            fetchNews();
        } catch (err) {
            setError('Failed to delete news');
            console.error('Error deleting news:', err);
        }
    };

    return (
        <div className="container py-4">
            <h1 className="h2 mb-4">News & Announcements Management</h1>

            {/* Add News Form */}
            <div className="card mb-4">
                <div className="card-body">
                    <h2 className="card-title mb-4">Add New Announcement</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Title *</label>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                className="form-control"
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Description *</label>
                            <textarea
                                name="description"
                                value={formData.description}
                                onChange={handleInputChange}
                                className="form-control"
                                rows="4"
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">External Link</label>
                            <input
                                type="url"
                                name="external_link"
                                value={formData.external_link}
                                onChange={handleInputChange}
                                className="form-control"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Internal Link</label>
                            <input
                                type="text"
                                name="internal_link"
                                value={formData.internal_link}
                                onChange={handleInputChange}
                                className="form-control"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Image</label>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                                className="form-control"
                            />
                        </div>

                        {error && <div className="alert alert-danger">{error}</div>}
                        {successMessage && <div className="alert alert-success">{successMessage}</div>}

                        <button
                            type="submit"
                            disabled={loading}
                            className="btn btn-primary"
                        >
                            {loading ? 'Adding...' : 'Add News'}
                        </button>
                    </form>
                </div>
            </div>

            {/* News List */}
            {/* <div className="card">
                <div className="card-body">
                    <h2 className="card-title mb-4">Existing Announcements</h2>
                    <div className="list-group">
                        {news.map(item => (
                            <div key={item.id} className="list-group-item">
                                <div className="d-flex justify-content-between align-items-start">
                                    <div>
                                        <h3 className="h5 mb-2">{item.title}</h3>
                                        <p className="text-muted">{item.description}</p>
                                        {item.image_path && (
                                            <img 
                                                src={item.image_path} 
                                                alt={item.title}
                                                className="img-fluid mt-2"
                                                style={{ maxWidth: '200px' }}
                                            />
                                        )}
                                        {item.external_link && (
                                            <a 
                                                href={item.external_link} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                className="d-block mt-2 text-primary"
                                            >
                                                External Link
                                            </a>
                                        )}
                                        {item.internal_link && (
                                            <a 
                                                href={item.internal_link}
                                                className="d-block mt-2 text-primary"
                                            >
                                                Internal Link
                                            </a>
                                        )}
                                    </div>
                                    <button
                                        onClick={() => handleDelete(item.id)}
                                        className="btn btn-danger btn-sm"
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div> */}
        </div>
    );
};

export default NewsManagement;